import SEODashboard from "@/components/SEODashboard";
import { useSeoMeta } from '@unhead/react';

export default function SEOPage() {
  useSeoMeta({
    title: 'Mining SEO Keyword Dashboard | MineralJobs',
    description: 'Explore mining industry SEO keywords, traffic ROI, and strategic insights for FIFO mine jobs and mineral careers.',
    ogUrl: 'https://www.mineraljobs.com/seo/',
    twitterCard: 'summary_large_image',
  });
  return (
    <main>
    <div className="min-h-screen pt-16" style={{ background: "#111827" }}>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12 text-center">
        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border mb-4 text-xs" style={{ borderColor: "rgba(249,115,22,0.3)", background: "rgba(249,115,22,0.08)", color: "#fb923c", fontFamily: "JetBrains Mono, monospace" }}>
          📊 SEO INTELLIGENCE
        </div>
        <h1 className="text-4xl sm:text-5xl font-black text-white mb-4" style={{ fontFamily: "Outfit, sans-serif" }}>
          Mining SEO <span style={{ color: "#f97316" }}>Dashboard</span>
        </h1>
        <p className="text-gray-400 text-lg">
          Real-time keyword data, ROI projections, and strategic insights to dominate mining job search rankings.
        </p>
      </div>
      <SEODashboard />
    </div>
    </main>
  );
}
